import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js"

gsap.registerPlugin(ScrollTrigger)

let imgZoomContainers = document.querySelectorAll('.img-zoom')

if (imgZoomContainers) {

  imgZoomContainers.forEach(container => {
    let img = document.querySelector('.img-zoom__img')
    let text = document.querySelector('.img-zoom__text')

    let imgZoomTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "top center",
        end: "bottom center+=200px",
        scrub: true,
        pin: text,
      }
    })

    imgZoomTimeline.fromTo(img, { scale: 0.5, yPercent: -25 }, { scale: 1, yPercent: 0, duration: 1 })
    imgZoomTimeline.fromTo(text, { xPercent: -25, }, { xPercent: 0, }, "<")
    imgZoomTimeline.to(img,  { duration: 3 })
    imgZoomTimeline.to(text,  {}, "<")
    imgZoomTimeline.to(img,  { scale: 0.5, yPercent: 25, duration: 1 })
    imgZoomTimeline.to(text,  { xPercent: -25 }, "<")
  });
}
